"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_CarePlan_Activity = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
var RTTI_CarePlan_Detail_1 = require("./RTTI_CarePlan_Detail");
exports.RTTI_CarePlan_Activity = t.recursion('ICarePlan_Activity', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        outcomeCodeableConcept: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        outcomeReference: t.array(RTTI_Reference_1.RTTI_Reference),
        progress: t.array(RTTI_Annotation_1.RTTI_Annotation),
        reference: RTTI_Reference_1.RTTI_Reference,
        detail: RTTI_CarePlan_Detail_1.RTTI_CarePlan_Detail
    });
});
//# sourceMappingURL=RTTI_CarePlan_Activity.js.map